<template>
    <div
        ref="mask"
        class="z-max fixed overflow-auto flex justify-center modal-window-zindex !-mx-0"
        :class="{
            'shadow-lg bg-smoke-400 overflow-y-scroll inset-0 md:pt-16': showOverlay,
            'md:pt-2 top-0 modal-align' : !showOverlay
        }"
        @mousedown.self="close"
    >
        <div
            id="modalWindowWrapper"
            :style="{ width: widthStyle }"
            class="modal-container bg-white relative top-0 flex flex-col self-start"
            :class="[
                className, {
                    'shadow-inner mx-auto' : showOverlay,
                    'shadow-lg mx-4 my-8 border border-gray-200' : !showOverlay,
                }
            ]"
        >
            <span @click="directClose" class="absolute top-0 right-0 mt-px pt-3 px-3 cursor-pointer text-gray-800 hover:text-red-600">
                <i @click="directClose" class="fa fa-times text-xl"></i>
            </span>
            <div class="text-md font-semibold leading-normal ml-6 mr-8 pt-3 pb-3" v-if="$slots.header">
                <slot name="header">
                    CommodityTrends
                </slot>
            </div>
            <div class="modal-body overflow-auto px-6 py-2 border-t border-b border-dotted border-gray-100">
                <slot name="body"></slot>
            </div>
            <div class="modal-footer px-6 py-3" v-if="$slots.footer">
                <slot name="footer">
                </slot>
            </div>
            <div class="modal-footer px-6 py-3" v-if="$slots.closebutton">
                <div class="flex justify-center">
                    <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="directClose">OK</div>
                </div>
                <slot name="closebutton">
                </slot>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const { width, className, overlay } = defineProps(['width', 'className', 'overlay']);

const emit = defineEmits(['close']);

const showOverlay = ref((typeof overlay === 'boolean') ? overlay : true);
const widthStyle = ref(width || '');

const close = () => {
    if (showOverlay.value) {
        emit('close');
    }
};

const directClose = () => {
    emit('close');
};

const blockContext = (event) => {
    event.preventDefault();
};

const watchForEscKey = (event) => {
    const isEscape = (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27);
    if (isEscape) {
        directClose();
    }
};

onMounted(() => {
    if (showOverlay.value) {
        document.addEventListener('contextmenu', blockContext);
        document.body.classList.add("overflow-hidden", "mr-4");
    }

    document.addEventListener('keydown', watchForEscKey);
});

onBeforeUnmount(() => {
    if (showOverlay.value) {
        document.removeEventListener('contextmenu', blockContext);
    }

    document.removeEventListener('keydown', watchForEscKey);
    document.body.classList.remove("overflow-hidden", "mr-4");
});
</script>


<style lang="scss">
.modal-window-zindex {
    z-index: 10000;
}

#modalWindowWrapper {
    // max-height: 88%;
    @media (max-width: 640px) {
        max-height: 100%;
    }

    .modal-footer {
        box-shadow: 0 -6px 8px -5px #e7e7e7;
    }

    ::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 10px;
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 6px;
        background-color: rgba(0,0,0,.1);
        -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
    }
}
</style>
